import app from "flarum/forum/app";
import Page from "flarum/common/components/Page";
import AffixedSidebar from "flarum/forum/components/AffixedSidebar";
import PlayerCard from "./PlayerCard";
import LoadingIndicator from "flarum/common/components/LoadingIndicator";
import listItems from "flarum/common/helpers/listItems";
import ItemList from "flarum/common/utils/ItemList";
import LinkButton from "flarum/common/components/LinkButton";
import Placeholder from "flarum/common/components/Placeholder";
import SelectDropdown from "flarum/common/components/SelectDropdown";
import {getOrLoadPlayerData} from "../../SteamProfiles";

export default class PlayerPage extends Page {
  private playerLoading = false;
  private playerData: any | boolean | null = null;
  private userXHR: XMLHttpRequest | null = null;
  private playerUser: any | null = null;

  oninit(vnode: any) {
    super.oninit(vnode);

    this.playerRefresh();
  }

  playerRefresh() {
    this.playerLoading = true;
    getOrLoadPlayerData(m.route.param("steamid")).then((data) => {
      this.playerData = data;
      app.setTitle(app.translator.trans("rhodes-island.forum.player.title") + data.personaname);
      app.setTitleCount(0);
    }).catch((err) => {
      if (err === null) {
        this.playerData = false;
      } else {
        this.playerData = null;
      }
    }).finally(() => {this.playerLoading = false;m.redraw()});
    m.request({
      url: app.forum.attribute("baseUrl") + "/api/steam/findUsers?steamids=" + m.route.param("steamid"),
      config: (xhr: XMLHttpRequest) => this.userXHR = xhr
    }).then((data: any) => {
      if (data.success) {
        this.playerUser = data.users[m.route.param("steamid")];
        m.redraw();
      }
    }).finally(() => this.userXHR = null);
  }

  view() {
    return (
      <div className="UserPage">
        {!this.playerLoading
          ? (this.playerData ? [
            <PlayerCard
              player={this.playerData}
              user={this.playerUser}
              className="Hero UserHero"
              controlsButtonClassName="Button"
            />,
            <div className="container">
              <div className="sideNavContainer">
                <AffixedSidebar>
                  <nav className="sideNav UserPage-nav">
                    <ul>{listItems(this.sidebarItems().toArray())}</ul>
                  </nav>
                </AffixedSidebar>
                <div className="sideNavOffset UserPage-content">{this.content()}</div>
              </div>
            </div>,
          ] : <Placeholder text={this.playerData === false ? app.translator.trans("rhodes-island.forum.player.invalid_player") : app.translator.trans("rhodes-island.forum.player.load_failed")}/>)
          : [<LoadingIndicator display="block" />]}
      </div>
    );
  }

  sidebarItems() {
    const items = new ItemList();

    items.add(
      'nav',
      <SelectDropdown className="App-titleControl" buttonClassName="Button">
        {this.navItems().toArray()}
      </SelectDropdown>
    );

    return items;
  }

  navItems() {
    const items = new ItemList();
    const ply = this.playerData;

    items.add(
      'zs-data',
      <LinkButton href={app.route('player.zs_data', { steamid: ply.steamid })} icon="fas fa-biohazard">
        {app.translator.trans('rhodes-island.forum.user.zs_data_link')}
      </LinkButton>,
      100
    );

    items.add(
      'scp-data',
      <LinkButton href={app.route('player.scp_data', { steamid: ply.steamid })} icon="fas fa-theater-masks">
        {app.translator.trans('rhodes-island.forum.user.scp_data_link')}
      </LinkButton>,
      90
    );

    return items;
  }

  content() {}

  abortUserXHR() {
    if (this.userXHR) this.userXHR.abort();
    this.userXHR = null;
  }
}
